export default function LandingFooter() {
  return (
    <footer className="border-t border-[rgba(43,36,20,0.18)] px-6 py-16">
      <div className="mx-auto flex max-w-xl flex-col items-center gap-6">
        <span
          className="text-[#2B2414] font-display"
          style={{
            fontWeight: 400,
            fontSize: 24,
            letterSpacing: '-0.01em',
          }}
        >
          HELIOS
        </span>
        <span
          className="text-[#7B7162] font-body"
          style={{
            fontWeight: 600,
            fontSize: 11,
            letterSpacing: '0.14em',
            textTransform: 'uppercase',
          }}
        >
          © 2026 KLEOS
        </span>
      </div>
    </footer>
  );
}
